import { useTranslation } from "react-i18next";
import ShipOutlineIcon from "../../../icons/shipOutlineIcon";
import TruckIcon from "../../../icons/truckIcon";
import ServicesCard from "./servicesCard";

const OurServices = () => {
  const { t } = useTranslation();
  return (
    <article className="bg-[#F9F8FE] md:h-[512px] py-10">
      <div className="flex flex-col justify-center w-11/12 h-full mx-auto">
        <h2 className="text-[32px] font-semibold text-mainBlue text-center">
          {t("ourServices")}
        </h2>
        <div className="flex flex-wrap items-center justify-between gap-4 mt-8">
          <ServicesCard
            Icon={<ShipOutlineIcon />}
            header={t("seaShipping")}
            text={t("integratedServices")}
            link={"/container-sizes"}
          />
          <ServicesCard
            Icon={<TruckIcon fill={"#0051FF"} />}
            header={t("landShipping")}
            text={t("fastTransport")}
            link={"/services/land-transportation"}
          />
          <ServicesCard
            Icon={<TruckIcon fill={"#0051FF"} />}
            header={t("airFreight")}
            text={t("costOptimized")}
            link={"/services/air-transportation"}
          />
        </div>
      </div>
    </article>
  );
};

export default OurServices;
